import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import permissions from './permissions';
import notifications from './modules/notifications';
import chatUnread from './modules/chatUnread';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    permissions,
    notifications,
    chatUnread
  },
  state: {
    // Global app state
    appLoading: false,
    chatComposerFocused: false,
    snackbar: {
      show: false,
      text: '',
      color: 'success'
    },
    confirmationDialog: {
      show: false,
      message: '',
      title: '',
      resolver: null
    }
  },
  mutations: {
    SET_APP_LOADING(state, loading) {
      state.appLoading = loading;
    },
    SET_CHAT_COMPOSER_FOCUSED(state, focused) {
      state.chatComposerFocused = Boolean(focused);
    },
    SHOW_SNACKBAR(state, { text, color = 'success' }) {
      state.snackbar = {
        show: true,
        text,
        color
      };
    },
    HIDE_SNACKBAR(state) {
      state.snackbar.show = false;
    },
    SHOW_CONFIRMATION_DIALOG(state, { message, title, resolver }) {
      state.confirmationDialog = {
        show: true,
        message,
        title: title || 'Confirm Action',
        resolver
      };
    },
    HIDE_CONFIRMATION_DIALOG(state) {
      state.confirmationDialog = {
        show: false,
        message: '',
        title: '',
        resolver: null
      };
    }
  },
  actions: {
    setChatComposerFocused({ commit }, focused) {
      commit('SET_CHAT_COMPOSER_FOCUSED', focused);
    },
    showSuccess({ commit }, payload) {
      // Support both string and object payloads
      if (typeof payload === 'string') {
        commit('SHOW_SNACKBAR', { text: payload, color: 'deep-purple' });
      } else {
        commit('SHOW_SNACKBAR', { text: payload.text, color: payload.color || 'deep-purple' });
      }
    },
    showError({ commit }, text) {
      commit('SHOW_SNACKBAR', { text, color: 'error' });
    },
    showInfo({ commit }, text) {
      commit('SHOW_SNACKBAR', { text, color: 'info' });
    },
    showWarning({ commit }, text) {
      commit('SHOW_SNACKBAR', { text, color: 'warning' });
    },
    showConfirmation({ commit }, { message, title }) {
      return new Promise((resolve) => {
        commit('SHOW_CONFIRMATION_DIALOG', { message, title, resolver: resolve });
      });
    },
    confirmDialog({ commit, state }) {
      if (state.confirmationDialog.resolver) {
        state.confirmationDialog.resolver(true);
      }
      commit('HIDE_CONFIRMATION_DIALOG');
    },
    cancelDialog({ commit, state }) {
      if (state.confirmationDialog.resolver) {
        state.confirmationDialog.resolver(false);
      }
      commit('HIDE_CONFIRMATION_DIALOG');
    }
  },
  getters: {
    appLoading: state => state.appLoading,
    chatComposerFocused: state => state.chatComposerFocused,
    snackbar: state => state.snackbar,
    confirmationDialog: state => state.confirmationDialog
  }
}); 